import TaskManage from "./simpler-task-manage";

export default TaskManage;
